import type { File, Folder } from '@efdigital/ll-addon-data';
import Component from '@glimmer/component';
import { Await } from '@warp-drive/ember';

interface FolderContentsSignature {
  Element: HTMLDivElement;
  Args: {
    folderAndContents: Folder;
    containerClass?: string;
    itemClass?: string;
  };
  Blocks: {
    folder: [folder: Folder];
    file: [file: File];
  };
}

export class FolderContents extends Component<FolderContentsSignature> {
  get containerClass() {
    return (
      this.args.containerClass ??
      'row row-cols-1 row-cols-md-3 row-cols-lg-4 g-3'
    );
  }

  get itemClass() {
    return this.args.itemClass ?? 'col';
  }

  get isEmpty() {
    return (
      this.args.folderAndContents.folders.length === 0 &&
      this.args.folderAndContents.files.length === 0
    );
  }

  <template>
    {{#if this.isEmpty}}
      <div class="text-center py-5">
        <p class="lead">This folder is empty.</p>
      </div>
    {{else}}
      <Await @promise={{@folderAndContents.folders}}>
        <:success as |folders|>
          <Await @promise={{@folderAndContents.files}}>
            <:success as |files|>
              <div class={{this.containerClass}}>
                {{#each folders as |folder|}}
                  <div class={{this.itemClass}}>
                    {{#if (has-block "folder")}}
                      {{yield folder to="folder"}}
                    {{/if}}
                  </div>
                {{/each}}
                {{#each files as |file|}}
                  <div class={{this.itemClass}}>
                    {{yield file to="file"}}
                  </div>
                {{/each}}
              </div>
            </:success>
          </Await>
        </:success>
      </Await>
    {{/if}}
  </template>
}
